/** @module SiteAdmin/3DMaterialForm **/
define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"underscore",
	"csi/comm/Aspera",
	"csi/html",
	"csi/image/_base",
	"csi/locale",
	"csi/util",
	"csi/widget/LabeledImage",
	"./3DDocumentForm"
], function(declare, Memory, _, Aspera, html, image, locale, util, RightWidgetImage, ThreeDDocumentForm) {

	const DEFAULT_IMAGE = "DefaultImage";
	const PREVIEW_HEIGHT = 100;
	const THREE_D_MATERIAL_EXTENSIONS = "u3m,fab,xtex";

	return declare(ThreeDDocumentForm, {
		rightWidgetClass: RightWidgetImage,

		constructor: function() {
			this._initializeFileType(THREE_D_MATERIAL_EXTENSIONS);
			this.fileLabel = locale.resource("3DMaterialZip");
		},

		/**
		 * Hides the default image if Aspera is enabled
		 */
		startup: function() {
			if (Aspera.isEnabled()) {
				this.getField("DefaultImage").bHidden = true;
			}

			return this.inherited(arguments);
		},

		on3DZipFile: function(bIsRequired, fileName) {
			this.extension = "u3m";
			this.inherited(arguments);

			var requiredFileText = locale.resource("OrConjunction", [locale.resource("3DU3M"), locale.resource("3DXTEX"), locale.resource("3DFAB")]);
			this.set("checkMessage", fileName || requiredFileText);
		},

		/**
		 * Update default image selection with new image lists
		 * @param {array} val
		 */
		onZipRead: function(val) {
			var fileField = this.getField(DEFAULT_IMAGE);
			var previewFileName = "";
			var filteredList = null;
			var scrollNode = this.scrollNode;
			var coloredMaterialDom = this.domNode.querySelector(".csi-3D-Material-checkbox");

			if (val.zip) {
				var validFormatFiles = _.filter(val.zip.files, (item) => {
					const ext = util.getFileExtension(item.name);

					if (ext === "fab" || ext === "xtex") {
						this.showColoredMaterialDom = false;
					}

					return (ext === "u3m") || (ext === "fab") || (ext === "xtex");
				});

				if (validFormatFiles.length) {
					let u3m;

					val.zip.file(validFormatFiles[0].name).async("string").then(function(u3m) {
						try {
							u3m = JSON.parse(u3m);
						} catch (err) {
							return;
						}

						//get the preview image from u3m file
						_.each(u3m, function(val) {
							if (val.Browzwear && val.Browzwear.preview) {
								previewFileName = val.Browzwear.preview.split("/").last();
							} else if (val.Vizoo && val.Vizoo.preview) {
								previewFileName = val.Vizoo.preview.split("/").last();
							}
						});
					});

					filteredList = _.filter(val.contents, function(item) {
						var isImage = image.isValidFormat(item.Name);

						if (isImage) {
							val.zip.file(item.Name).async("base64").then(function(src) {
								item.src = "data:image/" + item.ext + ";base64," + src;
								item.rawSrc = src;

								var imgName = item.Name.split("/").last();

								if (imgName) {
									if (imgName == previewFileName) {
										fileField.m_control.set("value", item.Name);
									} else {
										// The preview filename could not be found in any of the u3m jsons. Check to see if the image is named "preview"
										var lastPeriod = imgName.lastIndexOf(".");

										if (lastPeriod >= 0 && imgName.substr(0, lastPeriod) == "preview") {
											fileField.m_control.set("value", item.Name);
										}
									}

								}
								return (src);
							});
						}
						return isImage;
					});
				}
			}

			if (coloredMaterialDom && this.showColoredMaterialDom) {
				html.show(coloredMaterialDom);
			} else if (coloredMaterialDom) {
				html.hide(coloredMaterialDom);
			}

			this.zipFileStore = new Memory({
				data: filteredList,
				idProperty: "Name",
				labelProperty: "Name",
			});

			fileField.m_control.set("value", "");
			fileField.m_control.set("store", this.zipFileStore);

			$(scrollNode.parentNode).css({"min-height": (scrollNode.parentNode.offsetHeight <= (scrollNode.offsetHeight + PREVIEW_HEIGHT)) ? "360px" : ""});
		},

		/**
		 * Show selected image in the right pane of form
		 * @param {FormView} defView 
		 * @param {Field} field 
		 * @param {string} value 
		 */
		_onChangeDefaultImage(defView, field, value) {
			const item = field.m_control.item;
			this.rightWidget?.set("imageSrc", item?.src || "");
		},

		/**
		 * @override
		 * Add image rendering to default image field
		 */
		_resolveView() {
			this.inherited(arguments);

			// don't autofill node name to avoid form confusion
			this.defView.m_formData.setFieldInitialValue("Node Name", "");

			const defaultImageField = this.getField(DEFAULT_IMAGE);
			if (defaultImageField) {
				defaultImageField.m_label = locale.resource("3DSelectDefaultImg");
				defaultImageField.widgetParams = {
					labelType: "html",

					labelFunc(item, store) {
						const {Name: label, src} = item;

						if (src) {
							const div = html.create("div", {className: "csi-combo-box-image-card"});
							const imgDiv = html.create("div", null, div);
							html.create("img", {src}, imgDiv);
							html.create("div", {
								className: "csi-ellipsis-nowrap",
								innerText: label,
								title: label
							}, div);
							return div.outerHTML;
						}

						return label;
					}
				};
			}
		}

	});
});